import Vue from 'vue'
import Quiz from './Quiz.vue'
import VueSocialSharing from 'vue-social-sharing'

Vue.use(VueSocialSharing)

window.QuizApp = {
    start(anchor, quizData={}, quizSettings={}){
        const defaultQuizSettings = { repeatable:true, randomizeQuestions:false, randomizeAnswers:false }
        let _quizSettings = Object.assign({}, defaultQuizSettings, quizSettings)
        
        return new Vue({
            render: h => h(Quiz, {
                props: { quizData, _quizSettings }
            })
        }).$mount(anchor)
    }
}